/**
 * E-mail check of the sign-in / sign-up forms — the same rules as the server
 * (apps/server/src/auth.ts `isValidEmail`; keep both in step): trimmed and
 * lower-cased, no spaces, ≤ 254 characters, one "@", a dotted "atext" local
 * part of ≤ 64, a domain of letter/digit/hyphen labels with a dot and a
 * letter TLD of 2+ (or "xn--").
 */
export const EMAIL_MAX_LENGTH = 254;
const EMAIL_LOCAL = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*$/;
const EMAIL_DOMAIN = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+(?:[a-z]{2,63}|xn--[a-z0-9-]{1,59})$/;

export function normalizeEmail(raw: string): string {
  return raw.trim().toLowerCase();
}

export function isValidEmail(email: string): boolean {
  if (!email || email.length > EMAIL_MAX_LENGTH || /\s/.test(email)) return false;
  const at = email.lastIndexOf('@');
  if (at <= 0 || email.indexOf('@') !== at) return false;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1);
  return local.length <= 64 && domain.length <= 253 && EMAIL_LOCAL.test(local) && EMAIL_DOMAIN.test(domain);
}

/** What is wrong with a typed e-mail (null when fine), in the player's language. */
export function emailProblem(raw: string, en: boolean): string | null {
  const email = normalizeEmail(raw);
  if (!email) return en ? 'E-mail and password are required.' : 'O e-mail e a senha são obrigatórios.';
  if (email.length > EMAIL_MAX_LENGTH) return en ? 'That e-mail is too long (254 characters at most).' : 'Esse e-mail é longo demais (máximo de 254 caracteres).';
  if (/\s/.test(email)) return en ? 'An e-mail has no spaces.' : 'O e-mail não pode ter espaços.';
  if (!email.includes('@')) return en ? 'An e-mail needs an "@" (e.g. you@example.com).' : 'Falta o "@" no e-mail (ex.: voce@exemplo.com).';
  if (!isValidEmail(email)) return en ? 'Write a valid e-mail address (e.g. you@example.com).' : 'Escreva um endereço de e-mail válido (ex.: voce@exemplo.com).';
  return null;
}
